import React, { useState } from "react";
import "./FAQ.scss";
import { FAQConstants } from "./FAQConstants";
import fire from "../../../assets/images/icons/fire.png";

const FAQ: React.FC = () => {
    const { tag, title, viewAllText, faqItems } = FAQConstants;
    const [expandedIndex, setExpandedIndex] = useState<number>(0);

    const toggleFAQ = (index: number) => {
        setExpandedIndex(expandedIndex === index ? -1 : index);
    };

    return (
        <section className="faq-section">
            <div className="faq-container">
                <div className="faq-header">
                    <div className="faq-header-left">
                        <div className="faq-tag">
                            <img className="tag-icon" src={fire} alt="Flame icon" />
                            <span className="tag-text">{tag}</span>
                        </div>
                        <h2 className="faq-title">{title}</h2>
                    </div>
                    {/* <div className="faq-header-right">
                        <a href="#" className="view-all-btn" aria-label={viewAllText}>
                            <span className="view-all-label">{viewAllText}</span>
                            <span className="view-all-icon" aria-hidden="true">
                                <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                                    <path
                                        d="M6 14L14 6M14 6H8M14 6V12"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                        </a>
                    </div> */}
                </div>

                <div className="faq-items">
                    {faqItems.map((item, index) => (
                        <div
                            key={index}
                            className={`faq-item ${expandedIndex === index ? "expanded" : ""}`}
                        >
                            <button
                                className="faq-question"
                                onClick={() => toggleFAQ(index)}
                                aria-expanded={expandedIndex === index}
                            >
                                <span className="faq-number">
                                    {String(index + 1).padStart(2, "0")}
                                </span>
                                <span className="faq-text">{item.question}</span>
                                <span className="faq-icon">
                                    <svg
                                        width="28"
                                        height="28"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                    >
                                        <path
                                            d="M6 9L12 15L18 9"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                            </button>
                            <div className="faq-answer">
                                <p>{item.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
